module.exports = __webpack_public_path__ + "img/quinta.28a1d455.jpg";